export const MODE = {
  STORE: 'STORE',
  SERVICE_HUB: 'SERVICE_HUB'
}
